import {createRef, useEffect, useState} from 'react';
import Grid from "@mui/material/Grid2";
import Carousel from "react-multi-carousel";
import './Gallery.css';
import {CardContent, Paper} from "@mui/material";

function Gallery({images, selectedImageIndex}) {
    const [slideNr, setSlide] = useState(2);
    const ref = createRef();
    const responsive = {
        everyWhere: {
            breakpoint: {max: 4000, min: 0},
            items: 1
        }
    };

    const changePage = index => {
        ref.current.goToSlide(index + 2);
    };

    useEffect(() => {
        changePage(selectedImageIndex);
    }, [selectedImageIndex]);

    const maxHeight = 500;
    return (
        <Grid container maxHeight={{md: maxHeight}} sx={{pb: 3}} overflow="hidden">
            <Grid overflow={"auto"}
                  maxHeight={maxHeight}
                  className="gallery-controls"
                  size={{xs: 0, md: 1.6}}
                  gap={1}
                  sx={{
                      display: {sm: 'none', md: 'flex'},
                      flexDirection: 'column'
                  }}
            >
                {images.map(({alt, src, thumbnail}, index) => <Grid key={`${index}-${src}`} size={12} className="square">
                    <Paper
                        variant="outlined"
                        square
                        sx={{
                            borderColor: ((slideNr === (index + 2)) && 'secondary.main'),
                            position: "absolute",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            cursor: "pointer"
                        }}
                        onClick={() => changePage(index)}
                    >
                        <img key={`${index}-${src}`} alt={alt}
                             style={{width: '100%', height: '100%', objectFit: 'contain'}}
                             src={thumbnail || src}
                        />
                    </Paper>
                </Grid>)}
            </Grid>
            <Grid size={{xs: 12, md: 10.4}}>
                <CardContent sx={{px: {xs: 0, md: 2}, py: {md: 0}}}>
                    <Carousel
                        ref={ref}
                        responsive={responsive}
                        autoPlay={true}
                        autoPlaySpeed={10000}
                        swipeable
                        draggable
                        infinite
                        partialVisible={false}
                        pauseOnHover
                        arrows={false}
                        beforeChange={nextSlide => {
                            setSlide(nextSlide)
                        }}
                        afterChange={(previousSlide, state) => {
                            setSlide(state.currentSlide)
                        }}
                    >
                        {images.map(({alt, src}, index) =>
                            <CardContent key={`${index}-${src}`} sx={{
                                py: 0,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                height: '100%',
                                maxHeight: {sm: 700, md: maxHeight}
                            }}>
                                <img
                                    alt={alt}
                                    style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                    src={src}
                                    loading="lazy"/>
                            </CardContent>
                        )}
                    </Carousel>
                </CardContent>
                <Grid container
                      overflow={"auto"}
                      className="gallery-controls"
                      size={{sm: 12, md: 0}}
                      gap={1}
                      sx={{
                          display: {
                              sm: 'flex',
                              md: 'none'
                          },
                          flexDirection: 'row'
                      }}
                      wrap={'nowrap'}
                >
                    {images.map(({alt, src, thumbnail}, index) =>
                        <Grid key={src} size={1.6} flexShrink={0} className="square">
                            <Paper
                                variant="outlined"
                                square
                                sx={{
                                    borderColor: ((slideNr === (index + 2)) && 'secondary.main'),
                                    position: "absolute",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    cursor: "pointer"
                                }}
                                onClick={() => changePage(index)}
                            >
                                <img key={`${index}-${src}`} alt={alt}
                                     style={{width: '100%', height: '100%', objectFit: 'contain'}}
                                     src={thumbnail || src}/>
                            </Paper>
                        </Grid>)}
                </Grid>
            </Grid>

        </Grid>

    );
}

export default Gallery;
